"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function jsApiMethod() {
    return function (target, prop, descriptor) {
        var originalMethod = descriptor.value;
        descriptor.value = function () {
            var _this = this;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.loaded)
                return originalMethod.apply(this, args);
            if (prop.startsWith('is'))
                return false;
            if (prop == 'state')
                return '';
            if (prop == 'visitorData')
                return {};
            return new Promise(function (resolve) {
                _this.on('load', function () { return resolve(originalMethod.apply(_this, args)); });
            });
        };
        return descriptor;
    };
}
exports.jsApiMethod = jsApiMethod;
//# sourceMappingURL=decorators.js.map